import moment from 'moment'
export default {

    getWeekdayShortStringOfDate(date) {
        var dateTag = "-"
        return moment(date).locale(dateTag).format('ddd');
    },
    formatDateToString(date, format) {
        return moment(date).format(format);
    },
    getLocalDateTimeStringNow() {
        var date = new Date();
        var dateString = this.formatDate(date, 'YYYY-MM-DD') + ' ' + date.toLocaleTimeString();

        return dateString;
    },

    formatDate(date) {
        var format = "DD.MM.YYYY"
        var year = date.getFullYear();
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

        var formattedString;
        formattedString = format
            .replace("YYYY", year)
            .replace("MM", month)
            .replace("DD", day);

        return formattedString;
    },

    formatIsoDateString(dateString) {
        if (dateString == undefined)
            return undefined;

        if (dateString.indexOf('T') > 0) {
          dateString = dateString.substring(0, dateString.indexOf('T'));
        }

        var parts = dateString.split('-');
        var month = parts[1].slice(0) - 1; //month ranges from 0 to 11
        var day = parts[2];
        if (day.indexOf(' ') > 0) {
            var dayAndTime = parts[2].split(' ');
            day = dayAndTime[0];
        }
        var dateObj = new Date(parts[0], month, day, 0, 0, 0, 0);

        return dateObj.toLocaleDateString('de-DE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    },

    formatMinutesToWorkingHours(timeInMinutes) {
        if (timeInMinutes == undefined)
            return undefined;

        var hours = Math.trunc(timeInMinutes / 60);
        var minutes = (timeInMinutes % 60).toFixed(0);
        if (hours < 10) hours = '0' + hours;
        if (minutes < 10) minutes = '0' + minutes;

        return hours + ':' + minutes;
    }
}